import { Route } from "@tanstack/react-router"
import { channelIndexRoute } from "."
import { router } from "../../router"

export const channelFindByStreamKeyRoute = new Route({
  getParentRoute: () => channelIndexRoute,
  preSearchFilters: [(search) => search],
  path: "streamkey/$streamKey",
  onLoad: async ({ context: { trpcContext }, params: { streamKey } }) => {
    const channel = await trpcContext.channel.findByStreamKey.fetch({ streamKey })
    trpcContext.channel.findById.setData({ channelId: channel.channelId }, channel)

    void router.navigate({
      to: "/channels/edit/$channelId/details",
      params: { channelId: channel.channelId },
      replace: true,
    })
  },
})
